module.exports = __webpack_public_path__ + "783496c56c1d68ea809cffebd361a06b.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/head/gcapp.jpg
// module id = 628
// module chunks = 0